import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, formatApiError } from "../../lib/api";

export const SEC_ACTIONS = {
  "revoke-sessions": { label: "Cabut Semua Sesi", desc: "Semua sesi aktif akun ini diakhiri. Pengguna harus login ulang.", danger: false },
  "require-reverify": { label: "Minta Verifikasi Ulang", desc: "Semua sesi dan perangkat terpercaya dicabut. Login berikutnya wajib kode OTP email.", danger: false },
  deactivate: { label: "Nonaktifkan Akun", desc: "Akun tidak dapat login dan semua sesi/token lama langsung ditolak. Peringatan adalah indikator risiko, bukan bukti pelanggaran; pastikan tindakan proporsional.", danger: true },
  reactivate: { label: "Aktifkan Kembali", desc: "Akun aktif kembali. Semua perangkat terpercaya dicabut sehingga login berikutnya wajib kode OTP email.", danger: false },
  DITINJAU: { label: "Tandai Ditinjau", desc: "Catat hasil peninjauan awal.", danger: false },
  DITANGANI: { label: "Tandai Ditangani", desc: "Peringatan ditutup. Catat hasil pemeriksaan dan tindakan yang diambil.", danger: false },
};

export const SecurityActionDialog = ({ action, userId, alertId, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const meta = action ? SEC_ACTIONS[action] : null;
  const close = () => { setReason(""); onClose(); };
  const submit = async () => {
    setBusy(true);
    try {
      if (action === "DITINJAU" || action === "DITANGANI") await api.post(`/admin/security/alerts/${alertId}/status`, { status: action, note: reason });
      else await api.post(`/admin/security/users/${userId}/${action}`, { reason, alertId: alertId || null });
      toast.success(`${meta.label} berhasil dan tercatat di audit log`);
      setReason("");
      onDone();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={!!action} onOpenChange={(o) => !o && close()}>
      <DialogContent data-testid="security-action-dialog">
        <DialogHeader>
          <DialogTitle>{meta?.label}</DialogTitle>
          <DialogDescription>{meta?.desc}</DialogDescription>
        </DialogHeader>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Alasan / hasil pemeriksaan (wajib, minimal 5 karakter)" data-testid="security-action-reason" />
        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="security-action-cancel">Batal</Button>
          <Button disabled={busy || reason.trim().length < 5} onClick={submit} className={meta?.danger ? "bg-red-700 hover:bg-red-800" : "bg-emerald-800 hover:bg-emerald-900"} data-testid="security-action-confirm">
            Konfirmasi
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
